const INITIAL_STATE = {
  display: false,
  lastShow: null
}

const evaluationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ...state,
        display: true,
        lastShow: new Date()
      }
    case 'HIDE_MODAL':
      return {
        ...state,
        display: false,
        lastShow: null
      }
    default:
      return state
  }
}

export default evaluationReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/evaluationReducer.js